import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useCallback, useEffect, useState } from "react";
import { Col, FormControl, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import { IMediaCategory } from "../../../../../models/IMediaCategory";
import { listObjectType } from "../../../../../services/filters.service";
import { MultiSelectFilter, ObjectsCategoryIcon } from "../../../styled";
import { CardButton } from "../../products-manager/styled";

export function ProductsFilters(props: any) {
    const { t: translation } = useTranslation();
    const { showMaterialType = true } = props;

    const [query, setQuery] = useState("");
    const [filters, setFilters] = useState({})
    var filter: any = {};

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            handleOnChange(query, 'q');
        }, 500);
        return () => clearTimeout(timeOutId);
    }, [query])


    const handleOnChange = (event: any, field: any) => {
        filter = filters;
        if (field == 'q') {
            filter[field] = event;
        } else if (field == 'product_type') {
            filter[field] = event.value;
            setMaterialType(event.value)
        } else if (field == 'category_type') {
            filter[field] = event.value;
            setCategory(event.value)
        }
        setFilters(filter);
        handleSearch(filter);
    }

    const handleSearch = useCallback((_filter: any) => {
        props.handleFilter(_filter)
    }, [])


    // Material Type Filter
    const [materialType, setMaterialType] = useState(undefined);
    const materialTypeItems = [
        { label: translation('manager.type.discipline'), value: 'Discipline' },
        { label: translation('manager.type.object'), value: 'Media' },
        { label: translation('manager.type.theme'), value: 'Theme' },
        { label: translation('manager.type.unity'), value: 'Item' },
    ];

    //Object Category Filter
    const [categoriesItems, setCategoryItems] = useState(undefined);
    const [category, setCategory] = useState<IMediaCategory>();
    useEffect(() => {
        listObjectType().then(data => setCategoryItems(data))
    }, [])

    const categoryTemplate = (option: any) => {
        return (
            <div>
                <ObjectsCategoryIcon style={{ textAlign: 'left' }} className={`material-icons-${option.category_icon}`}>{option.category_icon.split(' ')[1]}</ObjectsCategoryIcon>
                <span style={{ verticalAlign: 'text-bottom', marginLeft: '5px' }}>{option.title}</span>
            </div>
        )
    }

    const handleButtonClear = useCallback(() => {
        setQuery("");
        setCategory(undefined);
        setMaterialType(undefined);
        setFilters({});
        handleSearch({});
    }, [])

    return (
        <>
            <Col xs={12} md={5}>
                <InputGroup className="mb-2 mt-sm-0 ds-input-group">
                    <InputGroup.Text id="basic-addon1"><FaSearch style={{ color: '#606060'}}></FaSearch></InputGroup.Text>
                    <FormControl
                        className="input-text"
                        placeholder={translation('manager.filters.product_search')}
                        aria-label={translation('manager.filters.product_search')}
                        aria-describedby="basic-addon1"
                        value={query}
                        onChange={(event: any) => setQuery(event.target.value)}
                    />
                </InputGroup>
            </Col>
            { showMaterialType &&
                <Col md={3} lg={{ span: 2, offset: 1 }} className="mb-2 mb-md-0 ps-md-0">
                    <MultiSelectFilter>
                        <Dropdown value={materialType}
                            placeholder={translation('manager.filters.product_type')} className="multiselect-dropdown ds-select"
                            options={materialTypeItems} onChange={(event: any) => handleOnChange(event, 'product_type')}
                        />
                    </MultiSelectFilter>
                </Col>
            }
            <Col md={2} lg={2} className="mb-2 mb-md-0 ps-md-0">
                <MultiSelectFilter>
                    <MultiSelect value={category} maxSelectedLabels={1} selectedItemsLabel={'{0} ' + translation('filters.selectedLabel')}
                        optionLabel="title" optionValue="id" placeholder={translation('manager.filters.object_type')} className="multiselect-dropdown ds-select"
                        options={categoriesItems} onChange={(event: any) => handleOnChange(event, 'category_type')} filter
                        itemTemplate={categoryTemplate} />
                </MultiSelectFilter>
            </Col>
            <Col md={2} lg={2} xxl={1} className="ps-md-0 mb-2">
                <CardButton>
                    <button name='addbutton' type='button' onClick={handleButtonClear}>
                        {translation('filters.clear')}
                    </button>
                </CardButton>
            </Col>
        </>
    )
}